export const getUpdateFiltersApiEndpoint = (queryParams, assignedFlag) =>
    assignedFlag
        ? `/occ/v2/${localStorage.getItem(
              'baseSiteId'
          )}/orders/filter?${queryParams}`
        : `/occ/v2/${localStorage.getItem(
              'baseSiteId'
          )}/orders/filter?${queryParams}&assignedFlag=${assignedFlag}`;
